import { FC, useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router";
import Logo from "@/assets/logo-with-text.png";
import Button from "./ui/Button";
import { FormInput } from "./ui/Form/FormInput";
import { CategoriesMenu } from "./CategoriesMenu";
import { observer } from "mobx-react-lite";
import appStore from "../stores/appStore";
import { useForm } from "react-hook-form";
import LoginModal from "../pages/AccountPage/components/LoginModal";
import CityModal from "./CityModal";
import { AuthResponse } from "../types/common";
import basketStore from "../pages/BasketPage/store/basketStore";
import locationSvg from '../assets/location_icon.svg'
import '../index.css';
import basketSvg from '../assets/cart_icon.svg';
import NewYearLights from "./NewYearLights";

interface SearchFormData {
  search: string;
}

const Header: FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    if(window.location.pathname == '/' || appStore.categories.length == 0) appStore.getCategories();
    if(window.location.pathname == '/' || appStore.cities.length == 0) appStore.getCities();
  }, []);

  const onSubmit = (data: SearchFormData) => {
    if (data.search.trim()) {
      window.location.href = `/search?search=${encodeURIComponent(
        data.search.trim()
      )}`;
    }
  };

  const [isOpenModal, setIsOpenModal] = useState(!appStore.selectedCity);

  const [isOpenModalLogin, setIsOpenModalLogin] = useState(
    ["/profile", '/profile/settings'].includes(location.pathname) && !appStore.isLoginIn
  );


  const { register, handleSubmit, setValue, watch } = useForm<SearchFormData>({
    defaultValues: {
      search: searchParams.get('search') || ""
    }
  });

  useEffect(() => {
    setIsOpenModalLogin(
      ["/profile", '/profile/settings'].includes(location.pathname) && !appStore.isLoginIn
    );
  }, [location.pathname]);

  return (
    <header>
      {/* <NewYearLights></NewYearLights> */}
      {/* верхняя полоска */}
        <div className="flex flex-row bg-[#333333] min-h-[37px] text-white p-2 justify-center">
        <div className="flex flex-row w-[1440px] self-center pl-[30px] pr-[30px] font-semibold text-[14px] tracking-[-2%]">
          <div className="flex flex-row justify-self-start items-center space-x-2 justify-center cursor-pointer">
            {/* <span className="text-xs">{appStore.dateSync}</span> */}
            <img src={locationSvg} alt="." className="h-[17px] w-[17px]" />
            <span
              onClick={() => setIsOpenModal(true)}
              className=" cursor-pointer"
            >
              {appStore.selectedCity || "Выбрать город"}
            </span>
          </div>
          <div className="flex-1"></div>
          <div className="flex place-self-end space-x-[25px]">
            <Link to={"/about"} className="!text-white">
              Доставка и оплата
            </Link>
            <Link to={"/about"} className="!text-white">
              О компании
            </Link>
          </div>
        </div>
      </div>
      {/* верхняя полоска end */}

      {/* основной хедер */}
      <div className="bg-white min-h-[77px] flex items-center px-4 gap-4 justify-center border-b-[#54545657] border-[1px]">
        {/* Логотип */}
        <div className="flex items-center px-4 gap-[30px] w-full max-w-[1440px]">
          <a href="/">
            <img
              src={Logo}
              className="w-auto h-[50px] flex-shrink-0 cursor-pointer"
              onClick={() => navigate("/")}
              alt="Логотип компании"
            />
          </a>

          {/* Контейнер для каталога и поиска */}
          <div className="flex flex-1 items-center gap-4">
            {/* Кнопка каталога */}
            <CategoriesMenu categories={appStore.categories} />

            {/* Форма поиска */}
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-1">
              <FormInput
                {...register("search")}
                placeholder="Название запчасти, артикул или марка"
                className="rounded-r-none w-full h-[55px] flex-1  border-none !bg-[#F2F2F7] !text-[16px] placeholder:font-medium"
                classNameForm="w-full"
                clearable
              />
              <Button
                style="primary"
                type="submit"
                className="!rounded-l-none !rounded-bl-none !rounded-r-[14px] !rounded-b-[14px] !rounded-t-[14px] !px-[28px] cursor-pointer   items-center  border-[2px] border-[#F2F2F7] !text-[18px] !p-0 h-[55px] text-center !flex !justify-center"
              >
                <span className="text-justify align-middle">Найти</span>
              </Button>
            </form>
          </div>

          {/* Навигационные ссылки */}
          <nav className="flex gap-[30px] items-center justify-center h-[55px] font-semibold text-[14px] ">
            <Link
            to="/profile/favorites"
            className="justify-center flex flex-col items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="25"
              viewBox="0 0 23 21"
              fill="none"
            >
              <path
                d="M11.5 20.7607C11.3496 20.7607 11.167 20.707 10.9521 20.5996C10.7373 20.4993 10.5332 20.3848 10.3398 20.2559C8.34896 18.9668 6.61589 17.6133 5.14062 16.1953C3.67253 14.7702 2.53385 13.3057 1.72461 11.8018C0.915365 10.2907 0.510742 8.76888 0.510742 7.23633C0.510742 6.2194 0.671875 5.29199 0.994141 4.4541C1.32357 3.61621 1.77474 2.8929 2.34766 2.28418C2.92773 1.67546 3.59375 1.20996 4.3457 0.887695C5.10482 0.558268 5.92122 0.393555 6.79492 0.393555C7.8763 0.393555 8.81087 0.66569 9.59863 1.20996C10.3936 1.75423 11.0273 2.46322 11.5 3.33691C11.9798 2.45605 12.6136 1.74707 13.4014 1.20996C14.1963 0.66569 15.1344 0.393555 16.2158 0.393555C17.0752 0.393555 17.8844 0.558268 18.6436 0.887695C19.4098 1.20996 20.0794 1.67546 20.6523 2.28418C21.2253 2.8929 21.6729 3.61621 21.9951 4.4541C22.3245 5.29199 22.4893 6.2194 22.4893 7.23633C22.4893 8.76888 22.0846 10.2907 21.2754 11.8018C20.4661 13.3057 19.3239 14.7702 17.8486 16.1953C16.3805 17.6133 14.6546 18.9668 12.6709 20.2559C12.4704 20.3848 12.2627 20.4993 12.0479 20.5996C11.8402 20.707 11.6576 20.7607 11.5 20.7607Z"
                fill="#262626"
              />
            </svg>
            Избранное
          </Link>
            <Link
              to="/profile"
              className=" flex flex-col items-center justify-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="25"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M2.88867 19.9873C2.26562 19.9873 1.77507 19.8441 1.41699 19.5576C1.06608 19.2783 0.890625 18.8916 0.890625 18.3975C0.890625 17.71 1.10189 16.9867 1.52441 16.2275C1.94694 15.4684 2.55566 14.7594 3.35059 14.1006C4.14551 13.4346 5.10156 12.8939 6.21875 12.4785C7.3431 12.0632 8.59993 11.8555 9.98926 11.8555C11.3857 11.8555 12.6426 12.0632 13.7598 12.4785C14.8841 12.8939 15.8402 13.4346 16.6279 14.1006C17.4229 14.7594 18.0316 15.4684 18.4541 16.2275C18.8838 16.9867 19.0986 17.71 19.0986 18.3975C19.0986 18.8916 18.9196 19.2783 18.5615 19.5576C18.2106 19.8441 17.7236 19.9873 17.1006 19.9873H2.88867ZM10 9.96484C9.20508 9.96484 8.47819 9.75358 7.81934 9.33105C7.16048 8.90137 6.63053 8.32845 6.22949 7.6123C5.83561 6.889 5.63867 6.07975 5.63867 5.18457C5.63867 4.31803 5.83561 3.53027 6.22949 2.82129C6.63053 2.10514 7.16048 1.53939 7.81934 1.12402C8.48535 0.701497 9.21224 0.490234 10 0.490234C10.7878 0.490234 11.5111 0.697917 12.1699 1.11328C12.8288 1.52865 13.3587 2.09082 13.7598 2.7998C14.1608 3.50163 14.3613 4.29297 14.3613 5.17383C14.3613 6.06901 14.1608 6.87826 13.7598 7.60156C13.3659 8.32487 12.8359 8.90137 12.1699 9.33105C11.5111 9.75358 10.7878 9.96484 10 9.96484Z"
                  fill="#262626"
                  // style="fill:#262626;fill:color(display-p3 0.1490 0.1490 0.1490);fill-opacity:1;"
                />
              </svg>
              {appStore.user?.name || "Аккаунт"}
            </Link>
            <Link
              to="/cart"
              className="whitespace-nowrap flex flex-col items-center relative "
            >
               <img src={basketSvg} alt="" className="w-[20px] h-[25px]"/>
              {basketStore.totalItems > 0 ? (
                <span className="absolute top-2 right-3 bg-[#383181] text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
                  {basketStore.totalItems}
                </span>
              ) : null}
              Корзина
            </Link>
          </nav>
        </div>
      </div>
      {/* основной хедер end */}
      <CityModal
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        isMobile={false}
      />

      <LoginModal
        isOpen={isOpenModalLogin}
        onClose={() => setIsOpenModalLogin(false)}
        onAuthSuccess={(data: AuthResponse) => appStore.onAuthCompleted(data)}
      ></LoginModal>
    </header>
  );
};

export default observer(Header);
